import React, { useEffect, useRef, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import authAction from '../../redux/auth/actions';

const { logoutPopup } = authAction;

const IdleTimer = ({ logoutPopup, access_token }) => {
  const [showModal, setShowModal] = useState(false);
  const idleTimerRef = useRef(null);
  const timeout = 15 * 60 * 1000; // 15 minutes in milliseconds

  const onIdle = () => {
    // Handle idle timeout: show modal
    setShowModal(true);
    localStorage.setItem('inactivityPopup', 'true');
  };

  const onActive = () => {
    // Handle user activity: reset timer only if not timed out yet, hide modal if shown
    const remaining = idleTimer.getRemainingTime();
    if (remaining < timeout) idleTimer.reset();
    // localStorage.removeItem('inactivityPopup');
    // setShowModal(false);
    console.log('User is active');
  };

  const handleLogout = () => {
    logoutPopup();
    localStorage.removeItem('inactivityPopup');
    setShowModal(false);
    window.location.href = '/signin';
    
  };

  const idleTimer = useIdleTimer({
    timeout,
    onIdle,
    onActive,
    debounce: 500
  });


  useEffect(() => {
    // Check on mount if popup was already triggered
    const inactivityPopup = localStorage.getItem('inactivityPopup');
    if (inactivityPopup === 'true') {
      setShowModal(true);
    } 
    // else {
    //   start();
    // }
  }, []);


  useEffect(() => {
     // Start idle timer if user is logged in and access_token is present
     if (access_token) {
       localStorage.removeItem('inactivityPopup');
       setShowModal(false);
       idleTimer.start();
     }
   }, [access_token]);

  useEffect(() => {
    // Optional: Log remaining time for debugging
    const interval = setInterval(() => {
      console.log('Remaining time:', idleTimer.getRemainingTime());
    }, 60000); // Log every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <Modal
      title="Session Expired"
      visible={showModal}
      closable={false}
      footer={[
        <Button key="logout" type="primary" onClick={handleLogout}>
          Logout
        </Button>,
      ]}
    >
      You have been inactive for 15 minutes. Your session has expired. Please logout and login again.
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    access_token: state.Auth.idToken,
  };
};

export default connect(mapStateToProps, { logoutPopup })(IdleTimer);